/**
 * App Reducers
 */
import { combineReducers } from 'redux';
import settings from './settings';
import ConfigReducer from './ConfigReducer';
import authUserReducer from './AuthUserReducer';
import LoadingReducer from './LoadingReducer';
import ScrollReducer from './ScrollReducer';
import OrderSupportReducer from './OrderSupportReducer';
import NotyReducer from './NotyReducer';
import FloatingButtonReducer from './FloatingButtonReducer';

const reducers = combineReducers({
  config: ConfigReducer,
  settings,
  authUser: authUserReducer,
  loading: LoadingReducer,
  scroll: ScrollReducer,
  orderSupport: OrderSupportReducer,
  noty: NotyReducer,
  floatingButton: FloatingButtonReducer,
});

export default reducers;
